import { Typography } from 'antd'
import { formatMoneyValue, isNegative, negateMoney, type Money } from '@/shared/lib/money'
import type { DistributionKind } from './stakeholderApi'

/** Manfiy summa qizil: zarar yoki ta'sischining kompaniyaga qarzi. */
export function SignedAmount({ value }: { value: Money }) {
  const text = formatMoneyValue(value)
  return isNegative(value) ? <Typography.Text type="danger">{text}</Typography.Text> : <>{text}</>
}

/** Zarar ulushi serverdan musbat keladi — ekranda minus bilan va qizil. */
export function ShareAmount({ value, kind }: { value: Money; kind: DistributionKind }) {
  return <SignedAmount value={kind === 'LOSS' && value.amount !== 0 ? negateMoney(value) : value} />
}
